import { Box } from "@mui/material";
import { styled } from "@mui/system";

const FlexBox = styled(Box)({
    display: "flex",
    alignItems: "center"
})

export default FlexBox;
